import { ENVIRONMENT } from '@/config/constants'
import type { ProductI } from '@/types'

const isDevEnv = ENVIRONMENT === 'development'

const productsColors: Record<string, string> = {
  insights: '#BF3385',
  reports: '#1064A3',
  compliance: '#04A956',
  ai: '#FDB512',
}

const products: ProductI[] = [
  {
    id: 'insights',
    name: 'Insights',
    url: isDevEnv
      ? 'https://insights.hubble.dev.gspcloud.com/'
      : 'https://insights.hubble.gspcloud.com/',
    description: 'Metrics and events',
    backgroundColor: productsColors.insights,
    comingSoon: false,
    hidden: false,
  },
  {
    id: 'reports',
    name: 'Reports',
    url: isDevEnv
      ? 'https://reports.hubble.dev.gspcloud.com/'
      : 'https://reports.hubble.gspcloud.com/',
    description: 'Certificates, PRISM and more',
    backgroundColor: productsColors.reports,
    comingSoon: false,
    hidden: false,
  },
  {
    id: 'ai',
    name: 'SUSAN AI',
    url: isDevEnv
      ? 'https://reports.hubble.dev.gspcloud.com/susan-ai-reports'
      : 'https://reports.hubble.gspcloud.com/susan-ai-reports',
    description: 'GENAI SUSAN — your Smart Unified Support & Analytics Navigator',
    backgroundColor: productsColors.ai,
    comingSoon: false,
    hidden: false,
  },
  {
    id: 'compliance',
    name: 'Compliance',
    url: isDevEnv
      ? 'https://compliance.hubble.dev.gspcloud.com/'
      : 'https://compliance.hubble.gspcloud.com/',
    description: 'Compliance reports and audits',
    backgroundColor: productsColors.compliance,
    comingSoon: false,
    hidden: false,
    badge: 'New',
  },
]

export default products
